//支付相关接口
import Http from '../Core/Http';
export default class Pay extends Http {
  constructor(config) {
    super(config);
  }
  //发起门诊缴费POST/api/Interaction/MobilePay
  MobilePay(data) {
    return this._post('api/Interaction/MobilePay', null, data)
  }
//便民门诊
MobilePayV3(data) {
  return this._post('api/Interaction/MobilePayV3', null, data)
}
  //发起住院预缴POST/api/Interaction/InpatientPrepayment
  InpatientPrepayment(data) {
    return this._post('api/Interaction/InpatientPrepayment', null, data)
  }

  //微信支付PostProcessPayment
  // PostProcessPayment(data) {
  //   return this._post('api/Payment/PostProcessPayment', data)
  // }

  //微信支付PostProcessPayment (加密后)
  PostProcessPayment(data) {
    return this._post('api/Payment/PostProcessPayment'+'?billId='+data, null,{})
  }

  //GetOrderById
  GetOrderById(data) {
    return this._get('api/Order/GetOrderById', data)
  }

  //退费
  RefundRequest(data) {
    return this._post('api/interaction/refundrequest', null, data)
  }
  //退费V2
  RefundRequestV2(data) {
    return this._post('api/interaction/refundrequestV2', null, data)
  }
  PostRefundV2({BillId}){
    return this._post(`api/Payment/PostRefundV2?billId=${BillId}`,null,{BillId})
  }
  VerifyPassword(data){
    return this._post(`api/Interaction/VerifyPaymentPassword`,null,data)
  }
}



// WEBPACK FOOTER //
// ./src/lib/PMA/Pay.js